import type { PointRecord } from '../types';

export async function loadPoints(): Promise<PointRecord[]> {
  const res = await fetch('/data/points.json');
  if (!res.ok) throw new Error('Failed to load points.json');
  const json = await res.json();
  return json as PointRecord[];
}

